import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import cx from 'classnames';
import Modal, { ModalActions, ModalContent, ModalHeader, ModalTitle } from "../components/Modal";
import { Button } from "../components/Button";
import { useSelector } from "react-redux";
import { selectCurrentOrgId } from "../store/models/Organization";
import { selectCurrentUserId } from "../store/models/User";
import { createSelector } from "reselect";
import { UpgradeThreshold, Urls } from '../constants';
import { selectAllQuotas } from '../store/models/Ai';
import { getPlanName } from '../utils';

const selector = createSelector(
  selectCurrentOrgId,
  selectCurrentUserId,
  selectAllQuotas,
  (organizationId, currentUserId, quotas) => ({
    organizationId,
    currentUserId,
    quotas
  })
)

export const IncreaseQuotaModal = ({ onRequestClose, orgId, upgradedPlan, error, setUpgradedPlan, quotaId, fetchQuotaId }) => {
  const { organizationId, currentUserId, quotas } = useSelector(state => selector(state));
  const history = useHistory();
  const notAuth = error === 'You are not authorized';
  const notMetThreshold = !Number.isNaN(Number.parseInt(error));
  const planName = getPlanName(quotas, quotaId);
  const threshold = UpgradeThreshold[planName];

  const handleClose = async () => {
    await fetchQuotaId();
    if (upgradedPlan) setUpgradedPlan();
    onRequestClose();
  }
  const onSendEmail = () => {
    window.open("mailto:support@thetaedgecloud.com" +
      "?subject=Increase%20Quota%20Request" +
      "&body=" +
      "%0A%0A%0A" +
      "User%20ID:%20" + currentUserId +
      "%0A" +
      "Organization%20ID:%20" + orgId +
      "%0A%0A");
  }

  const handleRedirect = () => {
    history.push(Urls.SETTINGS_BILLING);
    handleClose();
  }

  return (
    <Modal className={cx("IncreaseQuotaModal s")}
      onRequestClose={handleClose}>

      {!upgradedPlan && <ModalHeader>
        <ModalTitle>{notAuth ? '' : (notMetThreshold ? 'Increase Quota' : 'Contact us')}</ModalTitle>
      </ModalHeader>}

      <ModalContent>

        {!upgradedPlan && <div className={"short-content"}>{notAuth ?
          "Please contact your organization's admin to increase your quota." :
          ((threshold && notMetThreshold) ?
            `In order to increase your quota, please ensure a minimum purchase of $${threshold} worth of credits. Current purchased credits: $${error}.` :
            'In order to increase your quota, send us an email.')}
        </div>}
        {upgradedPlan && <div className={"short-content color-green"}>
          Congratulations! Your organization has been upgraded to the {upgradedPlan}.
        </div>}
        <div className={cx("error")}>
          {error && !notAuth && !notMetThreshold && error !== 'Please email support for your quota upgrade' && error}
        </div>
        <ModalActions>
          {upgradedPlan ? <Button color={"green"} title={"Confirm"} onClick={handleClose} />
            : <Button color={"green"}
              onClick={notAuth ? handleClose : notMetThreshold ? handleRedirect : onSendEmail}
              title={notAuth ? "Ok" : notMetThreshold ? "Go to Billing" : "Contact support"} />}
          {!upgradedPlan && <Button color={"transparent"} onClick={handleClose} title={"Close"} />}
        </ModalActions>

      </ModalContent>

    </Modal>);
}